import { api } from './client'
import type { Observacion, Turno } from '@/types/api'

export const turnosApi = {
  actual: () => api.get<Turno | null>('/turnos/actual').then((r) => r.data),
  abrir: (notas?: string | null) =>
    api.post<Turno>('/turnos/abrir', { notas: notas ?? null }).then((r) => r.data),
  cerrar: (notas?: string | null) =>
    api.post<Turno>('/turnos/cerrar', { notas: notas ?? null }).then((r) => r.data),
  agregarObservacion: (descripcion: string, monto: number) =>
    api
      .post<Observacion>('/turnos/actual/observaciones', { descripcion, monto })
      .then((r) => r.data),
  agregarObservacionAdmin: (turnoId: number, descripcion: string, monto: number) =>
    api
      .post<Observacion>(`/turnos/${turnoId}/observaciones`, { descripcion, monto })
      .then((r) => r.data),
  listar: (limit = 50) =>
    api.get<Turno[]>('/turnos', { params: { limit } }).then((r) => r.data),
  detalle: (id: number) => api.get<Turno>(`/turnos/${id}`).then((r) => r.data),
}
